module.exports = __webpack_public_path__ + "officialStatic/img/trusteeship4.9e078d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/xplan/trusteeship4.png
// module id = 8SZy
// module chunks = 0